import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "https://padi.com",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "PADI Global",
        "shortTitle": "PADI Global",
        "appKey": "b8316632-3911-40d7-8434-2a5be153b479",
        "language": "en",
        "languages": [
            "en",
            "de",
            "es",
            "fr"
        ],
        "links": {
            "invalidAuthenticationUrl": "https://store.padi.com/en-us/subscription/scuba-diving-magazine-digital-subscription/p/60579-1B2C/"
        },
        "buildNumber": 983533,
        "buildDate": "2025-07-25T18:34:56.982Z",
        "version": "2.10.10"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "login",
            "host": ""
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "padi",
            "config": {
                "clientId": "5k9k13qptse1qdcnpa7egk5bem",
                "verificationUrl": "https://piccoloapi.scubadiving.com/offer/recommendation",
                "auth": {
                    "enabled": true,
                    "type": "time",
                    "config": {
                        "reminderTime": 300,
                        "hardStopTime": 300,
                        "signUpUrl": "https://store.padi.com/en-us/subscription/scuba-diving-magazine-digital-subscription/p/60579-1B2C/",
                        "signInUrl": "https://account.padi.com/login/sign-in"
                    }
                }
            }
        },
        "legal": {}
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "gtag": {
            "trackerID": "GTM-54KRDL5"
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;